module.exports = __webpack_public_path__ + "img/otopack-150-active.ce0e51dd.svg";